<template>
	<div>

		<div class="body martop15">
			<el-row>
				<el-col :span="1" style="width:121px;padding-top: 8px ">
					<tiao :neir="'课程/班级添加'"></tiao>
				</el-col>
				<el-col :span="25" style="width:1100px;position: relative;">
					<div class="ksb_qh1_2">
						<span class="ksb_qh1_2_1">
							名称：
						</span>
						<input class="ksb_qh1_2_1_m" type="text" v-model="kc_name" name="s_name" required="">
						<span class="ksb_qh1_2_2">
							月龄：
						</span>
						<span class="ksb_qh1_2_2_3">
							<input class="ksb_qh1_2_2_3_i1_1" v-model="yueling" type="number" min="0" name="yueling">—
							<input class="ksb_qh1_2_2_3_i1_1" v-model="yueling2" type="number" min="0" name="yueling2">
						</span>
						<span class="ksb_qh1_2_1_2">
							耗课：
						</span>
						<input class="ksb_qh1_2_1_m" v-model="xiaohao" style="width:60px" type="number" min="0" name="xiaohao">
						<!--<span class="ksb_qh1_2_1_4">-->
							<!--合约类型：-->
						<!--</span>-->
						<!--<select class="select3" v-model="ketype" style="width:120px;height: 28px;padding-left:10px;float: left;margin-top: 8px;">-->
							<!--<option value="1">MOMYHOME</option>-->
							<!--<option v-for="item in option2" :value="item.id">-->
								<!--{{item.name}}-->
							<!--</option>-->
						<!--</select>-->
						<!--<span class="ksb_qh1_2_1_4" v-if="ketype==1">-->
							<!--关联教案：-->
						<!--</span>-->
						<!--<input type="text" v-if="ketype==1" placeholder="请输入关联教案名称" class="ksb_qh1_2_1_m" @input="search_jiaoan()" v-model="jiaoan">-->
						<!--<ul class="ul_list" v-show="ul_show">-->
							<!--<li v-for="item in name_list" @click="confirm_name(item.kc_id,item.kc_name)">-->
								<!--<span>{{item.kc_name}}</span>-->
							<!--</li>-->
							<!--<li v-if="name_list==''">暂无数据</li>-->
						<!--</ul>-->
						<input type="submit" value="确认添加" @click="add" class="ksb_qh1_3">
					</div>
				</el-col>

				<el-col :span="24" style="margin-top: 15px; ">
					<tiao :neir="'课程/班级列表'"></tiao>
				</el-col>
				<el-col :span="24" style="margin-top: 15px">
					<table class="table table-hover table-bordered">
						<thead>
							<tr>
								<th style="text-align: center;width: 30%;">课程/班级名称</th>
								<th style="text-align: center">月龄</th>
								<th style="text-align: center">所属</th>
								<th style="text-align: center">耗课</th>
								<!--<th style="text-align: center">合约类型</th>-->
								<!--<th style="text-align: center">关联教案</th>-->
								<th style="text-align: center">操作</th>
							</tr>
						</thead>
						<tbody style="text-align: center">
							<tr v-for="(item,index) in table_list">
								<td>{{item.kc_name}}</td>
								<td>{{item.yueling}}-{{item.yueling2}}</td>
								<td>{{item.belong}}</td>
								<td>{{item.xiaohao}}</td>
								<!--<td>{{item.item_name}}</td>-->
								<!--<td>{{item.zb_kc_name}}</td>-->
								<td>
									<el-button type="warning" v-if="item.belong != '总部'" @click="confirm_del(item.kc_id)" size="mini">删除</el-button>
								</td>
							</tr>
						</tbody>
					</table>

				</el-col>
			</el-row>

			<!--删除删除框-->
			<el-dialog title="删除" :visible.sync="dialogVisible" width="30%">
				<span style="font-size: 16px;">确认删除此课程？</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="success" @click="confirm_del">确 定</el-button>
				</span>
			</el-dialog>

			<div class="table-bottom">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage3"
				 background prev-text="上一页" next-text="下一页" :page-size="10" layout="prev, pager, next, jumper" :total="count">
				</el-pagination>
			</div>

		</div>

	</div>

</template>

<script>
	import tiao from '@/components/tiao'
	export default {
		components: {
			tiao
		},
		data() {
			return {
				value: '1',
				input5: '',
				token: '',
				table_list: [],
				kc_name: '', //课程名称
				yueling: '', //月龄
				yueling2: '', //月龄2
				xiaohao: '', //耗课
				dialogVisible: false, //删除弹出框
				kc_id: '', //课程ID
				currentPage3: 1,
				count: 0, //总条数
				ketype:1,
				option2:'',
				ul_show:false,
				jiaoan:'',
				name_list:'',
				kc_id:'',
			};
		},
		created() {
			let that = this;
			that.token = that.$cookies.get('token');

			that.get_data();
			// 合约类型
			$.ajax({
				type: 'post',
				url: process.env.apiUrl + "saas/Contract/item_see",
				dataType: 'json',
				data: {token:that.token},
				success: function(data) {
					console.log(data)
					that.option2 = data.data;
				},
				error: function() {
					that.$message.error(`请求失败`);
				}
			});
		},
		methods: {
			jump: function(d) {
				this.$router.push(d)
			},
			fanye: function(i) {

			},
			//表格数据
			get_data() {
				let that = this
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/kecsz/index",
					data: {
						token: that.token
					},
					success: function(data) {
						that.table_list = data.data
						that.count = data.map.count
					},
					error: function() {
						that.$message.error(`请求失败`);
					}
				});
			},
			//添加
			add() {
				let that = this
				if (that.kc_name.length == 0) {
					that.$message({
						message: "课程名称必须输入",
						type: 'error'
					});
					return;
				}
				if (that.yueling.length == 0 || that.yueling2.length == 0) {
					that.$message({
						message: "月龄范围必须输入",
						type: 'error'
					});
					return;
				}
				if (that.yueling < 0 || that.yueling2 < 0) {
					that.$message({
						message: "月龄范围不可小于0",
						type: 'error'
					});
					return;
				}
				if (Number(that.yueling) > Number(that.yueling2)) {
					that.$message({
						message: "月龄范围设置错误",
						type: 'error'
					});
					return;
				}
//				if (that.xiaohao.length == 0) {
//					that.$message({
//						message: "耗课数量必须输入",
//						type: 'error'
//					});
//					return;
//				}

				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/kecsz/add",
					data: {
						token: that.token,
						kc_name: that.kc_name,
						yueling: that.yueling,
						yueling2: that.yueling2,
						xiaohao: that.xiaohao,
						item_id:1,
						zb:'',
					},
					success: function(data) {
						if (data.status == 1) {
							that.open2()
							that.get_data()
							//清空数据
							that.kc_name = '';
							that.yueling = '';
							that.yueling2 = '';
							that.xiaohao = 0;
							that.jiaoan = '';
							that.ketype = 1;
						}
					},
					error: function() {
						self.$message.error(`请求失败`);
					}
				});
			},
			open2() {
				this.$message({
					message: '添加成功',
					type: 'success'
				});
			},
			//删除
			del(i) {
				let that = this
				that.dialogVisible = true
				that.kc_id = i
			},
			confirm_del(i) {
				let that = this
				that.$confirm('确认要删除此课程吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.kc_id = i
					$.ajax({
						type: 'post',
						url: process.env.apiUrl + "saas/kecsz/del",
						data: {
							token: that.token,
							kc_id: that.kc_id
						},
						success: function(data) {
							if (data.status == 1) {
								that.open3()
								that.get_data()
								that.dialogVisible = false
							} else {
								that.$message({
									message: data.msg,
									type: 'error'
								});
							}
						},
						error: function() {
							that.$message.error(`请求失败`);
						}
					});

				}).catch(() => {});
			},
			open3() {
				this.$message({
					message: '删除成功',
					type: 'success'
				});
			},
			// 关联教案
			search_jiaoan(){
				let that = this
				that.ul_show=true
				if(that.jiaoan==''){that.ul_show=false}
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/jiaoan/get_zb_class",
					data: {
						token: that.token,
						search:that.jiaoan
					},
					success: function(data) {
						console.log(data)
						that.name_list=data.data
					},
					error: function() {
						that.$message.error(`请求失败`);
					}
				});
			},
			// 确定教案
			confirm_name(id,name){
				this.jiaoan=name
				this.kc_id=id
				this.ul_show=false
			},
			//分页
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				let that = this;
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/kecsz/index",
					data: {
						token: that.token,
						page: val
					},
					success: function(data) {
						that.table_list = data.data
						that.count = data.map.count
					},
					error: function() {
						that.$message.error(`请求失败`);
					}
				});
			}
		}
	}
</script>

<style scoped>
	.body {
		padding-left: 45px;
		padding-right: 45px;
		font-size: 14px;
		color: #666;
	}

	ul {
		list-style: none;
	}

	.ksb {
		width: 94px;
		border-radius: 5px 5px 0 0;
		height: 38px;
		line-height: 38px;
		text-align: center;
		float: left;
		cursor: pointer;
	}

	.martop15 {
		margin-top: 15px;
	}

	.ksb_qh1_2 {
		width: auto;
		padding-right: 10px;
		height: 48px;
		float: left;
		border: 1px solid #dbdbdb;
		box-shadow: 1px 1px 2px #dbdbdb;
	}

	.ksb_qh1_2_1 {
		display: block;
		float: left;
		width: 58px;
		height: 48px;
		line-height: 48px;
		text-align: center;
	}

	.ksb_qh1_2_1_m {
		display: block;
		float: left;
		width: 130px;
		height: 30px;
		margin-top: 8px;
	}

	.ksb_qh1_2>span {
		display: block;
		float: left;
	}

	.ksb_qh1_2_2 {
		height: 48px;
		line-height: 48px;
		width: 48px;
		margin-left:20px;
	}

	.ksb_qh1_2>span {
		display: block;
		float: left;
	}

	.ksb_qh1_2_2_3 {
		/* width: 122px; */
		height: 48px;
		line-height: 48px;
	}

	.ksb_qh1_2>span {
		display: block;
		float: left;
	}

	.ksb_qh1_2_1_2 {
		width: 50px;
		height: 48px;
		line-height: 48px;
		margin-left:20px;
	}

	.ksb_qh1_2_2_3_i3 {
		width: 131px;
		height: 28px;
		margin-top: 8px;
	}

	.ksb_qh1_2_1_4 {
		/* width: 50px; */
		height: 48px;
		line-height: 48px;
		margin-left: 20px;
	}

	.ksb_qh1_3 {
		width: 130px;
		height: 34px;
		border-radius: 17px;
		background: #8CBB77;
		color: white;
		margin-left:20px;
		margin-top: 6px;
		text-align: center;
		line-height: 34px;
		border: none;
		outline:none;
		box-shadow: 1px 1px 4px #999;
		-webkit-box-shadow: 1px 1px 4px #999;
	}

	.ksb_qh1_2_2_3_i1 {
		width: 100px;
		height: 28px;
	}

	.table-bottom {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		display: -webkit-flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
	}

	.ksb_qh1_2_2_3_i1_1 {
		width: 50px;
		height: 28px;
	}

	.ksb_qh1_2_2_3_i3 {
		display: block;
		float: left;
		width: 154px;
		height: 30px;
		margin-top: 8px;
	}
	.ul_list {
		position: absolute;
		background-color: rgb(255, 255, 255);
		z-index: 999;
		border: 1px solid gray;
		padding: 3px 3px 7px;
		width: 130px;
		text-align: center;
		margin-top: 38px;
		right: 165px;
	}

	.ul_list li span {
		float: left;
		cursor: pointer;
		width:100%;
		margin-top: 5px;
	}
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/xitong/kechengs.vue